export const CONTENT_TYPE_ADAPTIVE_CARD =
  'application/vnd.microsoft.card.adaptive'
export const CONTENT_TYPE_HERO_CARD = 'application/vnd.microsoft.card.hero'

export const CONTENT_TYPE_NEWS = 'application/vnd.davi.retorik.card.news'
export const CONTENT_TYPE_POI = 'application/vnd.davi.retorik.card.poi'
export const CONTENT_TYPE_EMPTY = 'application/vnd.davi.retorik.card.empty'
export const CONTENT_TYPE_IMAGE = 'application/vnd.davi.retorik.card.image'
export const CONTENT_TYPE_LINK = 'application/vnd.davi.retorik.card.link'
export const CONTENT_TYPE_DISCOVER =
  'application/vnd.davi.retorik.card.discover'
export const CONTENT_TYPE_SUGGESTION =
  'application/vnd.davi.retorik.card.suggestion'
export const CONTENT_TYPE_SUGGESTEDACTION =
  'application/vnd.davi.retorik.card.suggestedaction'
export const CONTENT_TYPE_GRID = 'application/vnd.davi.retorik.card.grid'
export const CONTENT_TYPE_TILE = 'application/vnd.davi.retorik.card.tile'
export const CONTENT_TYPE_INTERNAL_COUNTER =
  'application/vnd.davi.retorik.card.counter'
export const CONTENT_TYPE_NAMED_LIST =
  'application/vnd.davi.retorik.card.namedlistitem'

export const CONTENT_TYPE_GRID_TITLE = 'application/vnd.davi.retorik.grid.title'
export const CONTENT_TYPE_MODAL_EXTERNALURI =
  'application/vnd.davi.retorik.modal.externaluri'

interface Media {
  url: string
  type?: number
  alt?: string
}

interface Image {
  url: string
  alt?: string
}

interface NewsContent {
  title: string
  subtitle: string
  text: string
  category?: string
  image?: Image
  media?: Array<Media>
  buttons?: Array<{
    type: string
    title: string
    value: string
  }>
}

interface AddressStructured {
  addressLocality?: string
  street?: string
  postalCode?: string
}

interface POIContentType {
  identifier?: string
  title?: string
  subtitle?: string
  text?: string
  addressStructured?: AddressStructured
  address?: string
  contact?: string
  phoneNumber?: string
  category?: {
    id: string
    label: string
  }
  media?: [
    {
      url?: string
      title?: string
      credits?: string
    }
  ]
  color?: string
  customerReviews?: number
  coordinates?: Coordinates
  downloadUri?: string
  favorite?: boolean
  review?: Review
  infoBanner?: string
  otherInformations?: Array<{
    title: string
    content: string | Array<string>
  }>
  tap?: {
    [option: string]: string
  }
  distance?: number
}

interface RecommandationButton {
  text: string
  eventName: string
  recommendationId?: string
}

interface DiscoverContentType {
  title: string
  recommandationButton: RecommandationButton
  mainButtons: ImageButton[]
  history?: boolean
  height?: number | undefined
}

interface ImageButton {
  Text: string
  MediaUrl: string
  EventName: string
  FilterId?: string | null
  FilterValue?: string | null
  FollowingCardText?: string | null
  Identifier?: string
}

interface Review {
  author?: {
    name?: string
    capacity?: string
  }
  comment?: string
  picture?: {
    url?: string
    description?: string
  }
}

interface Coordinates {
  latitude: number
  longitude: number
}

export type {
  Media,
  Image,
  NewsContent,
  AddressStructured,
  POIContentType,
  Coordinates,
  Review,
  RecommandationButton,
  DiscoverContentType,
  ImageButton
}
